var _circle, _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.456,
    cy: 36.663,
    r: 15.296,
    fill: "#0044EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.293 52.46c-4.24 0-8.226-1.65-11.224-4.647a15.762 15.762 0 0 1-4.649-11.221c0-4.239 1.652-8.224 4.65-11.221a15.77 15.77 0 0 1 11.223-4.647c4.24 0 8.226 1.65 11.224 4.647a15.762 15.762 0 0 1 4.648 11.22c0 4.24-1.65 8.224-4.648 11.222a15.773 15.773 0 0 1-11.224 4.647zm0-29.175c-7.34 0-13.31 5.97-13.31 13.306 0 7.337 5.97 13.307 13.31 13.307 7.34 0 13.31-5.969 13.31-13.306 0-7.337-5.97-13.307-13.31-13.307z",
    fill: "#020842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.267 42.79c-.346 0-.69-.14-.943-.414l-3.386-3.683a1.281 1.281 0 0 1 1.886-1.734l2.547 2.77 10.5-9.026a1.28 1.28 0 1 1 1.669 1.943L32.102 42.48a1.28 1.28 0 0 1-.835.31z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75c9.112 0 16.595-3.274 22.241-9.73C72.604 47.7 69.287 12.875 69.14 11.402c-.065-.637-.586-1.122-1.207-1.122-26.252 0-31.816-9.588-31.864-9.674-.423-.81-1.713-.81-2.136 0-.05.097-5.36 9.674-31.864 9.674-.621 0-1.142.485-1.207 1.122C.713 12.876-2.604 47.7 12.76 65.269 18.405 71.726 25.888 75 34.999 75zM3.186 12.777C24.343 12.56 32.398 6.2 35 3.252c2.602 2.947 10.657 9.308 31.815 9.525.435 6.115 1.785 35.766-11.376 50.817-5.167 5.908-12.043 8.904-20.44 8.904-8.393 0-15.268-2.994-20.434-8.9-13.157-15.04-11.813-44.706-11.38-50.82z",
    fill: "#020842"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.6e062c0e18078ab0e7a43c83bd4dc7d4.svg";
export { ForwardRef as ReactComponent };